// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const shieldon: PokeData = {
  "id": 410,
  "name": "shieldon",
  "height": 5,
  "weight": 570,
  "base_experience": 70,
  "types": [
    PokeType.ROCK,
    PokeType.STEEL
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "rock-slide",
    "protect",
    "endure",
    "swagger",
    "ancient-power",
    "taunt",
    "metal-sound",
    "iron-defense",
    "metal-burst",
    "earth-power",
    "iron-head",
    "stealth-rock",
    "heavy-slam"
  ],
  "moves": [
    "tackle",
    "rock-slide",
    "protect",
    "ancient-power",
    "metal-sound",
    "metal-burst",
    "earth-power",
    "stealth-rock",
    "metal-claw",
    "magnet-pull",
    "behemoth-bash",
    "steel-beam",
    "seismic-toss"
  ],
  "evolution_chain": {
    "id": 212,
    "item": null,
    "species": [
      {
        "name": "shieldon",
        "order": 438,
        "types": [
          PokeType.ROCK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "bastiodon",
        "order": 439,
        "types": [
          PokeType.ROCK,
          PokeType.STEEL
        ],
        "evolves_from_species_id": 410,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 66.5,
    "speed": 30,
    "ability_power": 42
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
